module.exports = __webpack_public_path__ + "static/media/lime-note-text.eda4e3ea.svg";